import { render, staticRenderFns } from "./AddFormula.vue?vue&type=template&id=0ed60cae&scoped=true"
import script from "./AddFormula.vue?vue&type=script&lang=js"
export * from "./AddFormula.vue?vue&type=script&lang=js"
import style0 from "./AddFormula.vue?vue&type=style&index=0&id=0ed60cae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed60cae",
  null
  
)

export default component.exports